import { useEffect, useState } from "react";
import {
  createServiceInicisBill,
  promotionGetInicisData,
  savePromotionInicisBill,
} from "src/service/pay";
import { useRecoilState } from "recoil";
import { productKeyAtom, userInfoAtom } from "src/atoms";
import {
  ICreateServiceBillReq,
  IPromotionGetInicisDataRes,
} from "src/service/types/pay.type";
import { insertInicisModule } from "src/utils/pay/insertInicisModule";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
import useProductInfo, { productNameMap } from "src/mocks/useProductInfo";
import PromotionCardLogin from "./PromotionCardLogin";
import { getUserInfoFromLocalStorage } from "src/utils/storage/auth";
const PayCard = () => {
  const { t } = useTranslation();
  const { lang } = useRouter();
  // const { routeTo } = useRouter();
  const [inicisData, setInicisData] = useState<IPromotionGetInicisDataRes>();
  const [currency, setCurrency] = useState<string>("WON");
  const [userInfo] = useRecoilState(userInfoAtom);
  const { productName } = useProductInfo();
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  // 결제 카드 교체 정보
  const payApply = async ({
    orderID,
    subscriptionID,
  }: {
    orderID: string;
    subscriptionID: string;
  }) => {
    // if (isCheckPay) {
    try {
      const serviceRequest: ICreateServiceBillReq = {
        billType: "PROMOTION",
        currency: "WON",
        licenseCount: 0,
        orderID: orderID,
        payCompany: "INICIS",
        payTerm: "year",
        serviceBillUid: "",
        subscriptionID: subscriptionID,
        userCode: userInfo.userCode,
      };

      const result = await createServiceInicisBill({ ...serviceRequest });

      if (result) {
        alert("결제완료");
      }
    } catch (error: any) {
      if (error.errorCode && error.errorMessage) {
        alert(error.errorMessage);
      }
    }
    // this.commonStore.setLoading(false);
    // }
  };
  const requestPay = async () => {
    // e.preventDefault();
    console.log("click requestPay");
    // // const result = await getInicisData({ price: 10 });
    // // setInicisData(result);
    // if (inicisData) {
    //   await payApply({ orderID: inicisData.oid, subscriptionID: "Inicis" });
    // }
    if (inicisData) {
      await savePromotionInicisBill({
        orderId: inicisData?.oid,
        promotionCode: inicisData?.promotionCode,
        totalPrice: inicisData?.price,
      });
    }
  };
  const billPrint_msg = t(
    "siteManagement.paymentHistory.bill.detail.includeVat"
  );
  useEffect(() => {
    console.log("userInfo", userInfo);
    insertInicisModule();
    async function init() {
      // const inicisData = await getInicisData({ price: 2000000 });
      // // const inicisData = await getInicisData({ price: 10 });
      // if (inicisData) setInicisData(inicisData);
      const promotionInicisData = await promotionGetInicisData();
      console.log("promotionInicisData", promotionInicisData);
      if (promotionInicisData) {
        setInicisData(promotionInicisData);
        setProductKey(promotionInicisData?.product);
      }
    }
    if (userInfo?.userName) {
      init();
    }
  }, [userInfo?.userName, setProductKey]);
  // const returnUrl = window.location.origin +
  // "/eco-cloud/wapi/cloud/pay/service/returnUrl/" +
  // payData?.oid +
  // "/" +
  // window.sessionStorage.getItem("product")
  const onClickPurchase = async () => {
    // @ts-expect-error
    const INIStdPay = window?.INIStdPay;
    INIStdPay.pay("inicisForm");
  };
  const cloudUserInfo = getUserInfoFromLocalStorage()
    ? JSON.parse(getUserInfoFromLocalStorage() as string)
    : null;
  return (
    <>
      {!cloudUserInfo ? (
        <PromotionCardLogin />
      ) : (
        <div>
          {/* 이니시스 PC 결제 폼 */}
          <form
            className="inicisForm"
            id="inicisForm"
            name="inicisForm"
            method="POST"
            style={{ display: "none" }}
          >
            <input name="version" readOnly value="1.0" />
            <input name="mid" readOnly value={inicisData?.mid} />
            <input
              name="goodname"
              readOnly
              required={true}
              // value={productName}
              value={productNameMap[inicisData?.product as string] ?? inicisData?.product}
            />
            <input name="oid" readOnly value={inicisData?.oid} />
            <input name="price" readOnly value={inicisData?.price} />
            <input name="currency" readOnly value={currency} />
            <input name="buyername" readOnly value={inicisData?.buyerName} />
            <input name="buyertel" readOnly value="010-0000-0000" />
            <input name="buyeremail" readOnly value={inicisData?.buyerEmail} />
            <input name="timestamp" readOnly value={inicisData?.timestamp} />
            <input name="signature" readOnly value={inicisData?.signature} />
            <input
              name="returnUrl"
              readOnly
              value={
                window.location.origin +
                "/eco-cloud/wapi/cloud/pay/promotion/returnUrl/" +
                // "/eco-cloud/wapi/cloud/pay/service/returnUrl/" +
                // "/eco-cloud/wapi/cloud/pay/service/returnUrl/custom/" +
                inicisData?.oid
                // +
                // "/" +
                // // "except"
                // window.sessionStorage.getItem("product")
              }
            />
            <input name="mKey" readOnly value={inicisData?.mKey} />
            <input name="gopaymethod" readOnly value="Card" />
            <input
              name="acceptmethod"
              readOnly
              value="below1000:billauth(card)"
            />
            <input name="billPrint_msg" readOnly value={billPrint_msg} />
            <input name="languageView" readOnly value={lang} />
            <input name="charset" readOnly value="UTF-8" />
            <input name="merchantData" readOnly value="" />
            <input name="tax" readOnly value="0" />
            <input name="taxfree" readOnly value="0" />
            <input
              type="hidden"
              readOnly
              name="closeUrl"
              value={window.location.href}
            />
          </form>

          {/* <span onClick={}> */}
          <button
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              e.preventDefault();
              onClickPurchase();
            }}
            onMouseDown={requestPay}
            className="btn btn-40 width w-100p mg mt-20 pd py-10"
            style={{
              width: "auto",
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "250px",
              marginBottom: "250px",
              backgroundColor: "#3182f6",
              color: "#ffffff",
            }}
          // onMouseDown={() => {
          //   requestPay();
          // }}
          // disabled={!confirmPolicy}
          >
            <span
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                className="mg mr-10"
                style={{ width: "16px", height: "12px" }}
                src="/resources/images/card.png"
              />
              {t("체크카드 또는 신용카드 결제하기")}
            </span>
          </button>
          {/* </span> */}
        </div>
      )}
    </>
  );
};

export default PayCard;
